import { render, staticRenderFns } from "./manage-queries-view.vue?vue&type=template&id=afa92464"
import script from "./manage-queries-view.vue?vue&type=script&lang=js"
export * from "./manage-queries-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports